import {createAction} from '@reduxjs/toolkit'
import {ControllerParams} from '@wix/yoshi-flow-editor'
import {Dispatch} from 'redux'
import {onInstanceChanged} from '../services/instance'

export const setInstance = createAction<string>('SET_INSTANCE')

export const watchInstance = (controller: ControllerParams['controllerConfig'], dispatch: Dispatch) =>
  onInstanceChanged(controller, instance => dispatch(setInstance(instance)))
